import React from "react";
import useIsomorphicLayoutEffect from "../useIsomorphicLayoutEffect.js";
export const SingletonEnvironmentContext = React.createContext({
    rtl: [false, () => { }],
    defaultViewport: "s",
});
export const useSingletonEnvironment = (defaultRTL) => {
    const state = React.useState(defaultRTL || false);
    const [isRTL, setRTL] = state;
    /**
     * Handle changing dir attribute directly
     */
    useIsomorphicLayoutEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName !== "dir")
                    return;
                const nextRTL = mutation.target.dir === "rtl";
                if (isRTL !== nextRTL)
                    setRTL(nextRTL);
            });
        });
        observer.observe(document.documentElement, { attributes: true });
        return () => observer.disconnect();
    }, [isRTL]);
    /**
     * Handle setRTL usage
     */
    useIsomorphicLayoutEffect(() => {
        document.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");
    }, [isRTL]);
    return state;
};
